import type { FC } from "react";

type DimensionTickProps = {
  point: { x: number; y: number };
  sizePx: number;
  strokeWidth: number;
  color: string;
};

// A short 45-degree "architectural tick" crossing a dimension line's endpoint, in place of an
// arrowhead - the same convention used elsewhere in this app's drawings (see DeckBottomViewCard).
const DimensionTick: FC<DimensionTickProps> = ({ point, sizePx, strokeWidth, color }) => {
  const half = sizePx / 2;

  return (
    <line
      x1={point.x - half}
      y1={point.y + half}
      x2={point.x + half}
      y2={point.y - half}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="square"
    />
  );
};

export default DimensionTick;
